<template>
  <ListOutputs />
</template>

<script>
import ListOutputs from '../../components/outputs/List';

export default {
  name: 'OutputsIndex',

  components: {
    ListOutputs
  }
};
</script>
